import { render, staticRenderFns } from "./agreementDialog.vue?vue&type=template&id=06d5295c&scoped=true"
import script from "./agreementDialog.vue?vue&type=script&lang=js"
export * from "./agreementDialog.vue?vue&type=script&lang=js"
import style0 from "./agreementDialog.vue?vue&type=style&index=0&id=06d5295c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d5295c",
  null
  
)

export default component.exports